// extracted by mini-css-extract-plugin
export default {"logoutFooter":"GlobalModal_logoutFooter__uXvVo","cancelButton":"GlobalModal_cancelButton__1ALbC","confirmButton":"GlobalModal_confirmButton__3SeQP"};